export default ({
  AGENTS_GET_LIST_FETCH_REQUEST: 'AGENTS_GET_LIST_FETCH_REQUEST',
  AGENTS_GET_LIST_FETCH_SUCCESS: 'AGENTS_GET_LIST_FETCH_SUCCESS',
  AGENTS_GET_LIST_FETCH_ERROR: 'AGENTS_GET_LIST_FETCH_ERROR',

  AGENTS_GET_BY_ID_FETCH_REQUEST: 'AGENTS_GET_BY_ID_FETCH_REQUEST',
  AGENTS_GET_BY_ID_FETCH_SUCCESS: 'AGENTS_GET_BY_ID_FETCH_SUCCESS',
  AGENTS_GET_BY_ID_FETCH_ERROR: 'AGENTS_GET_BY_ID_FETCH_ERROR',
  AGENTS_CREATE_FETCH_REQUEST: 'AGENTS_CREATE_FETCH_REQUEST',
  AGENTS_CREATE_FETCH_SUCCESS: 'AGENTS_CREATE_FETCH_SUCCESS',
  AGENTS_CREATE_FETCH_ERROR: 'AGENTS_CREATE_FETCH_ERROR',
  AGENTS_UPDATE_FETCH_REQUEST: 'AGENTS_UPDATE_FETCH_REQUEST',
  AGENTS_UPDATE_FETCH_SUCCESS: 'AGENTS_UPDATE_FETCH_SUCCESS',
  AGENTS_UPDATE_FETCH_ERROR: 'AGENTS_UPDATE_FETCH_ERROR',

  AGENTS_DELETE_FETCH_REQUEST: 'AGENTS_DELETE_FETCH_REQUEST',
  AGENTS_DELETE_FETCH_SUCCESS: 'AGENTS_DELETE_FETCH_SUCCESS',
  AGENTS_DELETE_FETCH_ERROR: 'AGENTS_DELETE_FETCH_ERROR',
  AGENTS_DUPLICATE_FETCH_REQUEST: 'AGENTS_DUPLICATE_FETCH_REQUEST',
  AGENTS_DUPLICATE_FETCH_SUCCESS: 'AGENTS_DUPLICATE_FETCH_SUCCESS',
  AGENTS_DUPLICATE_FETCH_ERROR: 'AGENTS_DUPLICATE_FETCH_ERROR',

  AGENTS_UPLOAD_DOCUMENT_FETCH_REQUEST: 'AGENTS_UPLOAD_DOCUMENT_FETCH_REQUEST',
  AGENTS_UPLOAD_DOCUMENT_FETCH_SUCCESS: 'AGENTS_UPLOAD_DOCUMENT_FETCH_SUCCESS',
  AGENTS_UPLOAD_DOCUMENT_FETCH_ERROR: 'AGENTS_UPLOAD_DOCUMENT_FETCH_ERROR',
  AGENTS_DELETE_DOCUMENT_FETCH_REQUEST: 'AGENTS_DELETE_DOCUMENT_FETCH_REQUEST',
  AGENTS_DELETE_DOCUMENT_FETCH_SUCCESS: 'AGENTS_DELETE_DOCUMENT_FETCH_SUCCESS',
  AGENTS_DELETE_DOCUMENT_FETCH_ERROR: 'AGENTS_DELETE_DOCUMENT_FETCH_ERROR',

  AGENTS_TEST_FETCH_REQUEST: 'AGENTS_TEST_FETCH_REQUEST',
  AGENTS_TEST_FETCH_SUCCESS: 'AGENTS_TEST_FETCH_SUCCESS',
  AGENTS_TEST_FETCH_ERROR: 'AGENTS_TEST_FETCH_ERROR',

  AGENTS_SET_SEARCH_FILTER: 'AGENTS_SET_SEARCH_FILTER',
  AGENTS_SET_STATUS_FILTER: 'AGENTS_SET_STATUS_FILTER',
  AGENTS_SET_PAGINATION: 'AGENTS_SET_PAGINATION',
});

